// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__uB-82","title":"styles_title__hbBH-","description":"styles_description__a5BcQ"};